// extracted by mini-css-extract-plugin
export var option = "_ky-0";
export var optionCard = "_ky-f";
export var optionContent = "_ky-g";
export var optionIcon = "_ky-i";
export var optionIconBox = "_ky-h";
export var optionLabel = "_ky-j";
export var optionPill = "_ky-m";
export var optionPillBadge = "_ky-p";
export var optionPillIcon = "_ky-n";
export var optionPillLabel = "_ky-o";
export var optionRadio = "_ky-k";
export var optionRadioInner = "_ky-l";
export var optionReveal = "_ky-2";
export var optionRevealDelay0 = "_ky-3";
export var optionRevealDelay1 = "_ky-4";
export var optionRevealDelay10 = "_ky-d";
export var optionRevealDelay11 = "_ky-e";
export var optionRevealDelay2 = "_ky-5";
export var optionRevealDelay3 = "_ky-6";
export var optionRevealDelay4 = "_ky-7";
export var optionRevealDelay5 = "_ky-8";
export var optionRevealDelay6 = "_ky-9";
export var optionRevealDelay7 = "_ky-a";
export var optionRevealDelay8 = "_ky-b";
export var optionRevealDelay9 = "_ky-c";
export var optionSelected = "_ky-1";